import { Editor } from "@tinymce/tinymce-react";
import { FC } from "react";
import { Props } from "./typings";

const plugins = [
  "advlist",
  "autolink",
  "lists",
  "link",
  "image",
  "preview",
  "anchor",
  "searchreplace",
  "visualblocks",
  "code",
  "fullscreen",
  "insertdatetime",
  "media",
  "table",
  "code",
  "help",
  "quickbars",
  "accordion",
];

const RichEditor: FC<Props> = ({
  register,
  content,
  setContent,
  disableToolbar = false,
  color = "#F4EFF4",
  allowShowCode = false,
  autoresize = false,
}) => {
  return (
    <Editor
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      value={content}
      onEditorChange={(text) => setContent(text)}
      init={{
        setup: (editor) => {
          register?.(editor);
        },
        resize_img_proportional: true,

        forced_root_block: "div",
        toolbar: disableToolbar
          ? ""
          : `bold italic underline | alignleft aligncenter alignright alignjustify | forecolor backcolor | bullist numlist | table | attachments` +
            (allowShowCode ? "| code" : ""),
        toolbar_mode: "floating",
        height: "100%",
        resize: false,

        browser_spellcheck: true,
        menubar: false,
        statusbar: false,
        plugins: disableToolbar
          ? []
          : autoresize
          ? [...plugins, "autoresize"]
          : plugins,
        automatic_uploads: true,
        images_upload_handler: (blobInfo): Promise<any> => {
          return new Promise((resolve) => {
            const base64 = blobInfo.base64();
            resolve("data:" + blobInfo.blob().type + ";base64," + base64);
          });
        },
        content_style: `body {margin-top: 0} .tox-tbtn--enabled { background: red; !important } .mce-content-body { background: ${color} !important;} .tox-toolbar__primary { background: ${color} !important } .tox-editor-header { background: ${color} !important;} .tox .tox-tbtn svg {fill: #ff0000!important;} summary{display:block; width:108px; cursor: pointer;  padding-left:8px; background:#d8d4da; border-radius:4px;} summary:hover{background: #a4a1a5}`,
        details_initial_state: "collapsed",
        details_serialized_state: "expanded",
        language: "pl",
        extended_valid_elements: "div[class|id]",
        quickbars_insert_toolbar: false,
      }}
    />
  );
};

export default RichEditor;
